import propTypes from 'prop-types'
import VideoBanner from './VideoBanner'
import WhatsAppButton from './WhatsAppButton'
import ImageBanner from '../assets/rooms/room-footer.webp'
import { memo } from 'react'

const CTA = ({
  title,
  cta,
  message,
  imageBanner,
  whatsappIconLeft,
  contact
}) => {
  return (
    <section className="CTA container-custom">
      {imageBanner ? <img src={ImageBanner} alt="Vida Cowork" title="Vida Cowork" className='CTA__ImageBanner' /> : <VideoBanner />}

      <div className="CTA__Text">
        { title }

        <div className="CTA__Button-Container">
          <p className="text-2">
            { cta }
          </p>

          <WhatsAppButton
            label="Reservar ahora"
            message={message}
            withIconLeft={whatsappIconLeft}
            contact={contact}
          />
        </div>
      </div>
    </section>
  )
}

CTA.propTypes = {
  title: propTypes.element,
  cta: propTypes.string,
  message: propTypes.string,
  imageBanner: propTypes.string,
  whatsappIconLeft: propTypes.bool,
  contact: propTypes.string
}

export default memo(CTA)